import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import IsoDate from '../types/IsoDate';
import RequestMetadata from './RequestMetadata';


const Event = types
    .model('Event', {
        id: types.optional(types.identifier, () => uuid()),
        type: types.maybe(types.string),
        timestamp: IsoDate,
        metadata: types.optional(RequestMetadata, {}),
        // Using frozen because details is static and exact type is not trivially inferable on creation
        details: types.maybe(types.frozen()),
    });

export default Event;
